import { NavLink, useLocation } from 'react-router-dom'
import { SidebarNav as CanonSidebarNav } from '@p31ca/design-core/compositions'
import { NAV_ITEMS } from '../lib/nav'

/** SidebarNav — the canon suite nav, composed as DATA + PORTS (rule 0). The
 *  compact forge has no drawer (profile 'compact' renders no drawer/rail): the
 *  nav data lives here for the mobile bottom nav + future surfaces, and the
 *  renderItem port keeps real react-router <a href> semantics. ≤15 lines. */
export function SidebarNav() {
  const { pathname } = useLocation()
  return (
    <CanonSidebarNav
      items={NAV_ITEMS}
      activePath={pathname}
      renderItem={(item) => (
        <NavLink
          to={item.path}
          end={item.path === '/'}
          className={({ isActive }) => `sidebar-nav__link${isActive ? ' is-active' : ''}`}
        >
          {item.emoji && <span aria-hidden="true">{item.emoji}</span>}
          <span>{item.label}</span>
        </NavLink>
      )}
    />
  )
}

export default SidebarNav